import React from 'react';
import {Link} from "react-router-dom";
import DropdownOptionList from "./dropdownOptionList";
import {stringContains} from "../../../../utils/utils";

DropdownRouteOption.propTypes = {};

function DropdownRouteOption(props) {
    const isActualRoute = stringContains(window.location.pathname , props.routeOrigin)
    return (
        <>
            <div onClick={event => {props.onClick(event)}}
                 style={{cursor: 'default'}}
                 className={isActualRoute ? 'top-bar__option_active' : 'top-bar__option'}>

                <div className="top-bar__option__line">
                    <div className="line"/>
                </div>

                <div style={{display: 'flex'}}>
					<a href={null} style={{cursor: 'default'}}>{props.title}</a>
                    <i style={{marginLeft: '10px', marginTop: '-2px', fontSize: '23px'}} className="fas fa-sort-down"/>
                </div>

                <DropdownOptionList routeList={props.routeList}/>
            </div>

        </>
    );
}

export default DropdownRouteOption;